import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './blogdetail.css';
import './blog.css';
import bar from './image/bar.jpg';
import axios from 'axios';
import angry from './image/angry.png';
import funny from './image/funny.png';
import love from './image/love.png';
import sad from './image/sad.png';
import surprised from './image/surprised.png';
import upvote from './image/upvote.png';
import { API_BASE_URL } from '../utils';

function BlogDetail() {
  const { title } = useParams();
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [blogDetails, setBlogDetails] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [recommendedBlogs, setRecommendedBlogs] = useState([]);
  const [blogs, setBlogs] = useState([]);

  const apiUrl = `${API_BASE_URL}/master/APIs/Web/getBlogsList`;
  const categoriesApiUrl = `${API_BASE_URL}/master/APIs/Web/getBlogCategroy`;
  const imgUrlPrefix = `${API_BASE_URL}/master/assets/uploads/`;

  useEffect(() => {

    const formData = new FormData();
    formData.append('blog_id', title);

    axios.post(`${API_BASE_URL}/master/APIs/Web/BlogsDetails`, formData)
      .then(response => {
        if (response.data && response.data.status) {

          setBlogDetails(response.data.data);
        } else {
          console.error("Failed to fetch blog details:", response.data.msg);
        }
      })
      .catch(error => {
        console.error("Error fetching blog details:", error);
      });


    axios.get(categoriesApiUrl)
      .then(response => {
        if (response.data && response.data.status) {
          setCategories(response.data.data);
        } else {
          console.error("Failed to fetch categories data:", response.data.msg);
        }
      })
      .catch(error => {
        console.error("Error fetching categories data:", error);
      });
  }, [title]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };


  function truncateText(htmlString, maxLength) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const textContent = doc.body.textContent || '';

    const words = textContent.trim().split(/\s+/);

    if (words.length <= maxLength) {
      return textContent;
    }

    const truncated = words.slice(0, maxLength).join(' ') + '...';
    return truncated;
  }



  useEffect(() => {
    setLoading(true);
    axios.get(apiUrl)
      .then(response => {
        if (response.data && response.data.status) {
          const fetchedBlogs = response.data.data;
          setBlogs(fetchedBlogs);
          const recommendeddata = fetchedBlogs.filter(
            (blog) => blog.title !== blogDetails.title
          );
          setRecommendedBlogs(recommendeddata);
        } else {
          console.error("Failed to fetch blog data:", response.data.msg);
        }
      })
      .catch(error => {
        console.error("Error fetching blog data:", error);
      }).finally(() => {
        setLoading(false);
      });
  }, [apiUrl, blogDetails.title]);



  return (
    <div className='blog-page'>


      <div className='blog-detail-aboutus'>
        <div className="blog-detail--wrapper">

          <div className='blog-detail--content'>
            <div className="blog-detail--grid--box-detail">
              <div className="blog-detail--item-link">
                <div className="blog-detail-c--box-1">
                  <img src={imgUrlPrefix + (blogDetails ? blogDetails.img : { bar })} alt={blogDetails ? blogDetails.title : 'Default Title'} />
                  <div className="blog-detail-content">
                    <p className='blog-detail-blog-pink'>{new Date(blogDetails.date_added).toDateString()}</p>
                    <h3 className='blog-detail-blog-h3'>{blogDetails.title}</h3>
                    <div className="blog-detail-blog-p-white" dangerouslySetInnerHTML={{ __html: blogDetails.des }}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='blog-detail-content-emoji'>
              <p>What do you think?</p>
              <div className='blog-detail-content-emoji-img'>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={upvote}></img>
                  <p>upvote</p>
                </div>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={love}></img>
                  <p>love</p>
                </div>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={funny}></img>
                  <p>funny</p>
                </div>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={surprised}></img>
                  <p>surprised</p>
                </div>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={sad}></img>
                  <p>sad</p>
                </div>
                <div className='blog-detail-content-emoji-img-content'>
                  <img src={angry}></img>
                  <p>a</p>
                </div>
              </div>
            </div>


            <div className='blog-detail-recommended-section'>
              <div className='blog-detail-recommended-header'>
                <h1>Recommended  Blogs</h1>
                <h1>
                <Link to="/blogs">
                  view all
                </Link>
                  </h1>
              </div>
              <div className='blog-detail-recommended'>

                {loading ? (
                  <>
                    {[...Array(4)].map((_, i) => (
                      <div className='blog-detail-recommended-card'>
                      <div className="blog-shimmer-card" key={i}>
                        <div className="blog-shimmer-image blog-shimmer"></div>
                        <div className="blog-shimmer-content">
                          <div className="blog-shimmer-title blog-shimmer"></div>
                          <div className="blog-shimmer-date blog-shimmer"></div>
                          <div className="blog-shimmer-text blog-shimmer"></div>
                          <div className="blog-shimmer-read blog-shimmer"></div>
                        </div>
                      </div>
                      </div>
                    ))}
                  </>
                ) : (
                  recommendedBlogs.map(blog => (
                    <div className='blog-detail-recommended-card'>
                      <Link
                        to={`/blogs/${blog.title.replace(/\s+/g, '-').toLowerCase()}`}
                        key={blog.title}
                        className="blog-card"
                      >
                        <div className="blog-card-category">{blog.category}</div>

                        <div className="blog-card-image">
                          <img src={imgUrlPrefix + blog.img} alt={blog.title} />
                        </div>

                        <div className="blog-card-content">
                          <h3 className="blog-card-title">
                            {blog.title.length > 20 ? blog.title.slice(0, 30) + '...' : blog.title}
                          </h3>
                          <p className="blog-card-date">{new Date(blog.date_added).toDateString()}</p>
                          <div
                            className="blog-card-description"
                            dangerouslySetInnerHTML={{ __html: truncateText(blog.des, 5) }}
                          />
                          <p className="blog-card-readmore">Read more...</p>
                        </div>
                      </Link>
                    </div>
                  )))}
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default BlogDetail;
